import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { User } from '@ee/common/models';

@Injectable({providedIn: 'root'})
export class UserSelectorService {
  private resourceUrl: string;
  private userSuggestions$: Observable<User[]>;

  constructor(private http: HttpClient, @Inject('environment') private environment) {
    this.resourceUrl = this.environment.api_prefix + 'api/users';
  }

  getUserSuggestions(): Observable<User[]> {
    if (!this.userSuggestions$) {
      this.userSuggestions$ = this.http.get<User[]>(`${this.resourceUrl}/suggestions`).pipe(
        shareReplay(1)
      );
    }
    return this.userSuggestions$;
  }
}
